import React from "react";
import { PieChart, Pie, Cell } from "recharts";

const REQUIRED_FIELDS = [
  { key: "summ", label: "Summary" },
  { key: "education", label: "Education" },
  { key: "email", label: "Email" },
  { key: "phone_n", label: "Phone Number" },
  { key: "daily_rate", label: "Daily Rate" },
  { key: "hourly_rate", label: "Hourly Rate" },
  { key: "city", label: "City" },
  { key: "country", label: "Country" },
  { key: "region", label: "Region" },
  { key: "hasLanguage", label: "Language(s)" },
  { key: "Available_from", label: "Availability" },
  { key: "hasSkill", label: "Skills" },
  { key: "hasIndustry", label: "Industry Preferences" },
  { key: "hasCV", label: "CV" },
  { key: "hasExperience", label: "Experience Details" },
  { key: "profilePicture", label: "Profile picture" },
];

// const COLORS = ["#365561", "#e5e7eb"]; // complete, incomplete
// const COLORS = ["#10B981", "#f3f4f6"];
// const COLORS = ["#0ea5e9", "#d1d5db"];
const COLORS = ["#2C7A7B", "#D1D5DB"];

const ProfileCompletionChart = ({
  profileData,
  hasCV,
  hasExperience,
  hasSkill,
  hasIndustry,
  hasLanguage,
}) => {
  const mergedData = {
    ...profileData,
    hasCV,
    hasSkill,
    hasLanguage,
    hasIndustry,
    hasExperience,
  };

  const missing = REQUIRED_FIELDS.filter(({ key }) => {
    const value = mergedData[key];
    if (typeof value === "boolean") return !value;
    if (Array.isArray(value)) return value.length === 0;
    if (typeof value === "object" && value !== null)
      return Object.keys(value).length === 0;
    return !value || value.toString().trim() === "";
  });

  const completedCount = REQUIRED_FIELDS.length - missing.length;
  const percent = Math.round((completedCount / REQUIRED_FIELDS.length) * 100);

  const data = [
    { name: "Complete", value: completedCount },
    { name: "Incomplete", value: missing.length },
  ];

  return (
    <div className="relative flex flex-col items-center cursor-pointer group w-fit">
      {/* Pie Chart as Hover Trigger */}
      <div className="relative z-10">
        <PieChart width={54} height={54}>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={15}
            outerRadius={25}
            startAngle={90}
            endAngle={-270}
            dataKey="value"
            stroke="none"
            isAnimationActive
          >
            {data.map((_, index) => (
              <Cell key={`cell-${index}`} fill={COLORS[index]} />
            ))}
          </Pie>
        </PieChart>

        {/* Center Text */}
        <div className="absolute inset-0 flex items-center justify-center cursor-pointer">
          <span className="text-[10px] text-gray-200 font-semibold">{percent}%</span>
        </div>
      </div>

      {/* Tooltip on Hover */}
      {missing.length > 0 && (
        <div className="absolute right-full top-1/2 -translate-y-1/2 z-50 w-52 bg-white border border-gray-200 shadow-lg rounded p-2 text-xs text-gray-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          <p className="font-medium mb-1">Missing fields:</p>
          <ul className="list-disc list-inside space-y-0.5">
            {missing.map((item) => (
              <li key={item.key}>{item.label}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ProfileCompletionChart;
